import { Tooltip, Button } from "@chakra-ui/react";

export interface TenantLicense {
  licenseType: number;
  noOfUsers: number;
  licenseStartDate: string; // ISO Date String
  licenseEndDate: string; // ISO Date String
  availableLicenses: number;
  assignedLicenses: number;
  isLicenseActive: boolean;
  title: string;
  maxTokenPerMonth: number |null;
  licenceTypeName: string | null;
  totalSlots: number | null;
}

export interface OrganizationData {
  id: number;
  tenantID: string;
  name: string;
  description: string;
  phoneNumber: string;
  email: string;
  address: string;
  isActive: boolean;
  teamAppID: string;
  licenses: TenantLicense[];
}

export const renderLicenseIcon = (licenceTypeName: string | null) => {
  switch (licenceTypeName) {
    case "Basic":
      return (
        <Tooltip label="Basic License" placement="top">
          <Button size="sm" colorScheme="blue" mr={2}>
            <i className="bi bi-file-earmark-text"></i>
          </Button>
        </Tooltip>
      );
    case "Pro":
      return (
        <Tooltip label="Pro License" placement="top">
          <Button size="sm" colorScheme="green" mr={2}>
            <i className="bi bi-star"></i>
          </Button>
        </Tooltip>
      );
    case "Enterprise":
      return (
        <Tooltip label="Enterprise License" placement="top">
          <Button size="sm" colorScheme="purple">
            <i className="bi bi-building"></i>
          </Button>
        </Tooltip>
      );
    default:
      return <span>No License</span>;
  }
};
